"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessLineTypeComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const StickinessLineTypeComponent = (props) => {
    const onClickMenu = ({ key }) => {
        props.onChange(key);
    };
    const renderInputLabel = () => {
        switch (props.value) {
            case LineTypeJSONModel_1.LineType.cumulative:
                return "Cumulative";
            case LineTypeJSONModel_1.LineType.nonCumulative:
                return "Non Cumulative";
            default: {
                if (process.env.NODE_ENV === "development") {
                    return React.createElement(React.Fragment, null,
                        "Unknown value: ",
                        props.value);
                }
                return null;
            }
        }
    };
    const items = (0, react_1.useMemo)(() => {
        return [
            { key: LineTypeJSONModel_1.LineType.nonCumulative, label: "Non Cumulative" },
            { key: LineTypeJSONModel_1.LineType.cumulative, label: "Cumulative" },
        ];
    }, []);
    const renderMenu = () => {
        return React.createElement(antd_1.Menu, { onClick: onClickMenu, items: items });
    };
    return React.createElement(antd_1.Form.Item, null,
        React.createElement(antd_1.Dropdown, { overlay: renderMenu, trigger: ["click"], disabled: false },
            React.createElement(antd_1.Button, null,
                renderInputLabel(),
                " ",
                React.createElement(icons_1.DownOutlined, null))));
};
exports.StickinessLineTypeComponent = StickinessLineTypeComponent;
